<template>
 <div :class="windowClass">
      <v-toolbar class="ma-2" dense flat>
        <v-spacer/>
          <v-btn class="ma-1" small v-if="checked.status=='Verified'" @click="print =true"><v-icon left>mdi-printer</v-icon> Print</v-btn>
         <v-btn class="ma-1" small v-if="dr.status=='booking'" @click="dr.status ='on-process',Save()"><v-icon left>mdi-file</v-icon> Issue D.R. #</v-btn>
         <!-- <v-btn class="ma-1" small v-if="dr.status=='outbound'" @click="dr.status ='on-process',Save()"><v-icon left>mdi-undo</v-icon> Re-Process</v-btn> -->
        <v-btn class="ma-1" small v-if="dr.status=='loaded' || dr.status=='outbound'" @click="dr.status ='on-process',Save()"><v-icon left>mdi-undo</v-icon> Re-Process</v-btn>
        <v-btn class="ma-1" small color="primary" v-if="dr.status=='on-process'" @click="dr.status ='loaded',Save()"><v-icon left>mdi-truck-delivery</v-icon> Load</v-btn>
      </v-toolbar>
        <v-row class="ma-1">
            <v-col cols="4">
                <v-text-field
                  v-model="dr.number"
                  label="D.R. #:"
                  @change="Save()"
                  :disabled="!EDIT"
                  dense
                  outlined
                  filled
                />
                 <v-text-field
                  label="DATE"
                  :value="dr.created | moment($date_format)"
                  dense
                  outlined
                  :disabled="true"
                  filled
                />
                 <v-autocomplete
                  v-model="dr.salesman"
                  label="SALESMAN"
                  :items="GET_SALESMEN()"
                  item-text="fullname"
                  item-value="id"
                  dense
                  outlined
                  :disabled="!EDIT"
                  filled
                   @change="Save()"
                />
            </v-col>  
             <v-col cols="4">
               <v-text-field
               :value="route"
               label="Route Code"
               dense
                  outlined
                     :disabled="true"
                  filled
               />
               <v-autocomplete
                  v-model="dr.truck"
                  label="ASSIGNED TRUCK"
                  :items="$store.state.trucks"
                  item-text="name"
                  item-value="id"
                   :disabled="!EDIT"
                  dense
                  outlined
                  filled
                />
                <v-autocomplete
                  v-model="dr.driver"
                  label="ASSIGNED DRIVER"
                   :disabled="!EDIT"
                  :items="$store.state.drivers"
                  item-text="fullname"
                  item-value="id"
                  dense
                  outlined
                  filled
                />
            </v-col>
            
             <v-col cols="4">
                 <v-text-field
                 :value="dr.status"
                  label="STATUS"
                  dense
                  outlined
                  :disabled="true"
                  filled
                />
                 <v-text-field
                 v-if="dr.status == 'outbound' || dr.status == 'inbound'"
                    :value="dr.outbound_date | moment($date_format)"
                  label="OUTBOUND DATE"
                  dense
                  outlined
                  :disabled="true"
                  filled
                />
                 <v-text-field
                    v-if="dr.status == 'inbound'"
                   :value="dr.inbound_date | moment($date_format)"
                  label=" INBOUND DATE"
                  dense
                  outlined
                  :disabled="true"
                  filled
                />

               
                
            </v-col>

              <v-col cols="12">
                <v-card>
                  <v-toolbar dense color="secondary" dark>
                     FULL CONTENTS
                     <v-spacer/>
                     <v-icon @click="fullform=true" v-if="EDIT">mdi-plus-box</v-icon>
                  </v-toolbar>
                 
                       <v-data-table
                    class="va-table"
                    dense
                    :headers="full_headers"
                    :items="fulls"
                    disable-pagination
                    hide-default-footer
                    >
                    <template v-slot:body="{ items }">
                        <tbody>
                        <tr v-for="(item,index) in items" :key="index">
                          <td><v-icon v-if="EDIT" small left color="error" @click="RemoveItem(item)">mdi-delete</v-icon> {{item.product_code}}</td>
                          <td>{{item.description}}</td>
                           <td class="text-right">{{item.quantity}}</td>
                              <td class="text-right">{{$money(item.unit_price)}}</td>
                          <td class="text-right">{{$money($IsNum(item.unit_price) * $IsNum(item.quantity) )}}</td>
                        </tr>
                         <tr style="background: #efefef;">
                              
                               <th colspan="4" class="text-right">TOTAL LOAD VALUE </th>
                              <th class="text-right">{{$money(LOAD_TOTAL)}}</th>
                          </tr>
                        
                        </tbody>
                    </template>
                </v-data-table>
                  <v-row dense class="pa-1">
                    <v-col cols="6">
                      <v-icon color="secondary" left small>mdi-truck-outline</v-icon> <span class="sm-font">{{VOLUME_PROGRESS.remarks}}</span>
                      <v-progress-linear :color="VOLUME_PROGRESS.color" :value="VOLUME_PROGRESS.value"></v-progress-linear>
                    </v-col>
                     <v-col cols="6">
                       <v-icon color="secondary" left small>mdi-weight</v-icon>  <span class="sm-font">{{WEIGHT_PROGRESS.remarks}}</span>
                       <v-progress-linear :color="WEIGHT_PROGRESS.color" :value="WEIGHT_PROGRESS.value"></v-progress-linear>
                    </v-col>
                  </v-row>
                 
                </v-card>
             </v-col>
       </v-row>

  <v-row dense class="ma-2"  v-if="dr.status =='inbound'">
             <v-col cols="6">
                <v-card>
                  <v-toolbar dense color="secondary" dark>
                      GENERATED - RETURNED FULLS
                    <v-spacer/>
                  </v-toolbar>
                       <v-data-table
                    class="va-table"
                    dense
                    :headers="returned_headers"
                    :items="returned_fulls"
                    disable-sort
                     disable-pagination
                    hide-default-footer
                    >
                    <template v-slot:body="{ items }">
                        <tbody>
                        <tr v-for="(item,index) in items" :key="index">
                           <td>{{item.product_code}}</td>
                            <td class="text-right">{{item.quantity}}</td>
                        </tr>
                        </tbody>
                    </template>
                </v-data-table>
                 
                </v-card>
             </v-col>
           
             <v-col cols="6">
                <v-card>
                  <v-toolbar dense color="secondary" dark>
                       GENERATED - RETURNED EMPTIES
                     <v-spacer/>
                  </v-toolbar>
                       <v-data-table
                    class="va-table"
                    dense
                    :headers="returned_headers"
                    :items="returned_empties"
                    disable-sort
                     disable-pagination
                    hide-default-footer
                    >
                    <template v-slot:body="{ items }">
                        <tbody>
                        <tr v-for="(item,index) in items" :key="index">
                          <td>{{item.product_code}}</td>
                          <td class="text-right">{{item.refund}} </td>
                        </tr>
                        </tbody>
                    </template>
                </v-data-table>
                 
                </v-card>
             </v-col> 


               <v-col cols="6">
                <v-card>
                  <v-toolbar dense color="secondary" dark>
                      CHECKER - RETURNED FULLS
                    <v-spacer/>
                  </v-toolbar>
                 
                       <v-data-table
                    class="va-table"
                    dense
                    :headers="returned_headers"
                      :items="checked.full_items?checked.full_items:[]"
                    disable-sort
                     disable-pagination
                    hide-default-footer
                    >
                    <template v-slot:body="{ items }">
                        <tbody>
                        <tr v-for="(item,index) in items" :key="index">
                           <td>{{item.code}}</td>
                            <td class="text-right">{{item.qty}}</td>
                        </tr>
                        </tbody>
                    </template>
                </v-data-table>
                 
                </v-card>
             </v-col>
           
             <v-col cols="6">
                <v-card>
                  <v-toolbar dense color="secondary" dark>
                       CHECKER - RETURNED EMPTIES
                     <v-spacer/>
                  </v-toolbar>
                       <v-data-table
                    class="va-table"
                    dense
                    :headers="returned_headers"
                      :items="checked.empty_items?checked.empty_items:[]"
                    disable-sort
                     disable-pagination
                    hide-default-footer
                    >
                    <template v-slot:body="{ items }">
                        <tbody>
                        <tr v-for="(item,index) in items" :key="index">
                          <td>{{item.code}}</td>
                          <td class="text-right">{{item.qty}} </td>
                        </tr>
                        </tbody>
                    </template>
                </v-data-table>
                 
                </v-card>
             </v-col> 
          <v-col cols="12">
          <v-toolbar dense class="md-font">
            <span v-if="checked.id != 0" :class="STATUS_TEXT(checked.status)">{{checked.status}}</span>
            <span v-else class="text-warning">Not yet checked!</span>
            <v-spacer/>
              <v-btn small v-if="checked.status != 'Verified'" color="error" @click="confirm=true"><v-icon>mdi-undo</v-icon> Reset Inbound Data</v-btn>
              <v-btn small color="success" class="ml-2" @click="Verified('Verified')" v-if="checked.status == 'For Verification'" ><v-icon>mdi-check</v-icon> Verified</v-btn>
              <v-btn small v-if="checked.status == 'Verified'" color="warning" @click="Verified('On Going')"><v-icon>mdi-undo</v-icon> Re-Check</v-btn>
          </v-toolbar>
          </v-col>
              <v-col cols="12">
                <v-card>
                  <v-toolbar dense color="secondary" dark>
                      SALES
                     <v-spacer/>
                      
                  </v-toolbar>
                 
                       <v-data-table
                    class="va-table"
                    dense
                    :headers="sales_headers"
                    :items="sales"
                    disable-sort
                    hide-default-footer
                    >
                    <template v-slot:body="{ items }">
                        <tbody>
                        <tr v-for="(item,index) in items" :key="index">
                          <td>{{item.invoice}} 
                          </td>
                            <td>{{item.trade_name}}</td>
                            <td>{{item.delivered_date | moment($date_format)}}</td>
                            <td>{{item.payment_type}}</td>
                            <td class="text-error">{{other_discounts(item.discounts)}}</td>
                            <td class="text-right">{{$money(item.amount)}}</td>
                        </tr>
                        <tr style="background: #efefef;">
                              <th class="text-right">CASH: {{$money(CASH_SALES)}}</th>
                              <th  class="text-right">CHEQUE: {{$money(CHEQUE_SALES)}}</th>
                              <th  class="text-right">CREDIT: {{$money(CREDIT_SALES)}}</th>
                              <th  class="text-right text-error">OTHER DISC.: {{$money(OTHERDISCOUNTS)}} </th>
                              <th class="text-right">TOTAL NET VALUE SOLD - CONTENTS</th>
                              <th class="text-right">{{$money(SALES_TOTAL)}}</th>
                          </tr>
                        </tbody>
                    </template>
                </v-data-table>
                 
                </v-card>
             </v-col>

             <v-col cols="12">
                <v-card>
                  <v-toolbar dense color="secondary" dark>
                      SETTLEMENT
                      <v-spacer/>
                    </v-toolbar>
                  <v-data-table
                      class="va-table"
                      dense
                      :headers="summary_headers"
                      :items="SUMMARY"
                      disable-sort
                      hide-default-footer
                      >
                      <template v-slot:body="{ items }">
                          <tbody>
                          <tr v-for="(item,index) in items" :key="index" >
                            <td>{{item.label}}</td>
                            <td class="text-right">{{$money(item.fulls)}}</td>
                            <td class="text-right">{{$money(item.deposit)}}</td>
                            <td class="text-right">{{$money(item.empties)}}</td>
                            <td class="text-right text-warning">{{$money(item.discount)}}</td>
                            <td class="text-right">{{$money(item.amount)}}</td>
                          </tr>
                          <tr style="background: #efefef;" :class="SETTLEMENT_AMOUNT<0?'text-error':'text-success'">
                                <th colspan="5" class="text-right">SETTLEMENT AMOUNT</th>
                                <th class="text-right">{{$money(SETTLEMENT_AMOUNT)}}</th>
                            </tr>
                          </tbody>
                      </template>
                  </v-data-table>
                </v-card>
             </v-col>
             
  </v-row>
     <print-delivery :show="print" :sales="sales" :dr="dr" :empties="empties" :fulls="fulls" :checked="checked" :returned_empties="returned_empties" :returned_fulls="returned_fulls" @DialogEvent="printEvent"/>
    <va-confirm :show="confirm" okbtn="Continue" cancelbtn="no" text="Reset inbound data? Note: This action will also remove all sales associated on this D.R. number" @DialogEvent="confirmEnvent"/>
     <va-full-form :show="fullform" method="delivery" :itemid="parseInt(this.$route.params.id)" @DialogEvent="fullEvent"/>
  </div>
</template>
<script>
import { API_MIXINS } from '@/mixins/api_mixins.js'
import {
  mapMutations
} from 'vuex'
  export default {
    mixins: [API_MIXINS],
    data: () => ({
      confirm: false,
      print: false,
      payform: false,
       borrowform: false,
        fullform: false,
        form2: false,
        sales_headers: [
        { text: 'INVOICE', value: 'product_code', sortable: false},
        { text: 'CUSTOMER', value: 'description', sortable: false},
        { text: 'DATE', value: 'description'},
        { text: 'PAYMENT', value: 'payment_type'},
         { text: 'OTHER DISC'},
        { text: 'AMOUNT',  align: 'right',sortable: false },
         ],
         full_headers: [
        { text: 'CODE', value: 'product_code', sortable: false},
        { text: 'DESC', value: 'description', sortable: false},
        { text: 'QTY', value: 'quantity', align: 'right', sortable: false},
        { text: 'UNIT PRICE', align: 'right', value: 'unit_price', sortable: false},
        { text: 'AMOUNT',  align: 'right',sortable: false },
         ],
         returned_headers:[
            { text: 'CODE'},
            { text: 'QTY', align: 'right'},
        ],
       summary_headers:[
              { text: 'VALIDATION'},
              { text: 'FULL CONTENTS', align: 'right'},
              { text: 'DEPOSIT',align: 'right'},
              { text: 'RETURNED EMPTIES', align: 'right'},
              { text: 'DISCOUNT', align: 'right'},
              { text: 'AMOUNT', align: 'right'},
        ],
        DiscountTypes: ["Trade Deals", "Pick-up Discount", "Cash Discount", "Other"],
        dr:{},
        empties: [],
        discounts:[],
        fulls: [],
        sales:[],
        returned_empties:[],
        returned_fulls:[],
        checked:{},
        checker_empties:[],
        checker_fulls:[],
        route:''
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.SET_MENUS()
          this.setLoggedIn(true) 
          this.GET_USERS()
          this.GET_TRUCKS()
          this.GET_DRIVERS()
          this.GET_SUPPLIERS()
           this.GET_PRODUCTS()
          this.getDr()
          this.GET_AVAILABLES()
          this.GET_SETTINGS()
        }
    },
    computed:{
      CASH_SALES() {
        var total= this.sales.reduce((res,item)=>{
            if(item.payment_type == 'Cash'){
              res += this.$IsNum(item.amount)
            }
            return res
        },0)
        return total
      },
       CHEQUE_SALES() {
        var total= this.sales.reduce((res,item)=>{
            if(item.payment_type == 'Cheque'){
              res += this.$IsNum(item.amount)
            }
            return res
        },0)
        return total
      },
       CREDIT_SALES() {
        var total= this.sales.reduce((res,item)=>{
            if(item.payment_type == 'Credit'){
              res += this.$IsNum(item.amount)
            }
            return res
        },0)
        return total
      },
      OTHERDISCOUNTS() {
         var total= this.sales.reduce((res,item)=>{
            res += this.$IsNum(this.other_discounts(item.discounts))
            return res
        },0)
        return total
      },
      VOLUME_PROGRESS(){
        var vol = 0
        var val = 0
         if(this.TRUCK.capacity) {
            vol =  this.fulls.reduce((res, item)=>{
              res += this.$IsNum(item.quantity) * this.$IsNum(item.volume) 
              return res
            },0)
            val =  ((vol/this.$IsNum(this.TRUCK.capacity)) * 100).toFixed(0)
         }
        var param = {
            value: this.$IsNum(val),
            color: val<80?'success':'error', 
            remarks: this.$IsNum(val) + "% Load"
        }
        return param
      },
      WEIGHT_PROGRESS(){
        var weight = 0
         var val = 0
        if(this.TRUCK.weight) {
            weight =  this.fulls.reduce((res, item)=>{
              res += this.$IsNum(item.quantity) * this.$IsNum(item.weight) 
              return res
            },0)
            val =  ((weight/this.$IsNum(this.TRUCK.weight)) * 100).toFixed(0)
        }
         
        var param = {
            value: this.$IsNum(val),
            color: val<80?'success':'error', 
            remarks: this.$IsNum(val) + "% Load"
        }
        return param
      },
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
      EDIT() {
        if(this.dr.status=='on-process'){
            return true
        }
        return false
      },
      TRUCK() {
         if(this.$store.state.trucks == undefined || this.$store.state.trucks == null) {
          return []
        }
        var arr = this.$store.state.trucks.reduce((res, item)=>{
            if(item.id==this.dr.truck) {
             res = item
            }
            return res
        },{})
        return arr
      },
      CONTAINERS(){
        var arr =  this.$store.state.products.reduce((res, item)=>{
            if(item.type=="empties"  && item.sort>0) {
                res.push(item)
            }
            return res
        },[])
        return arr
      },
      EMTPTIESTOTAL() {
        var total =  this.empties.reduce((res, item)=>res += (this.$IsNum(item.deposit) - this.$IsNum(item.refund)) * this.$IsNum(item.unit_price),0)
        return total
      },
      LOAD_TOTAL() {
        var total =  this.fulls.reduce((res, item)=>res += this.$IsNum(item.quantity)* this.$IsNum(item.unit_price),0)
        return total
      },
      DISCOUNT_TOTAL:function(){
        return this.SOLD_TOTAL + this.SOLD_DEPOSIT_TOTAL - this.RETURNED_EMPTIES_TOTAL - this.SALES_TOTAL
      },
      SALES_TOTAL() {
          var total =  this.sales.reduce((res, item)=>res += this.$IsNum(item.amount),0)
          return total
      },
       RETURNED_FULLS_TOTAL() {
          var total =  this.returned_fulls.reduce((res, item)=>res += this.$IsNum(item.quantity)* this.$IsNum(item.unit_price),0)
          return total
      },
      RETURNED_EMPTIES_TOTAL() {
          var total =  this.returned_empties.reduce((res, item)=>res += this.$IsNum(item.refund)* this.$IsNum(item.unit_price),0)
          return total
      },
      CHECKER_EMPTIES_TOTAL() {
           var data = this.checked.empty_items?this.checked.empty_items:[]
          var total =  data.reduce((res, item)=>res += this.$IsNum(item.qty) * this.$IsNum(item.unit_price),0)
          return total
      },
      CHECKER_FULLS_TOTAL() {
          var data = this.checked.full_items?this.checked.full_items:[]
          var total =  data.reduce((res, item)=>res += this.$IsNum(item.qty) * this.$IsNum(item.unit_price),0)
          return total
      },
      SOLD_DEPOSIT_TOTAL() {
          var total =  this.returned_empties.reduce((res, item)=>res += this.$IsNum(item.deposit)* this.$IsNum(item.unit_price),0)
          return total
      },

      SOLD_TOTAL(){
          return this.LOAD_TOTAL - this.RETURNED_FULLS_TOTAL 
      },
      CHECKER_SOLD_TOTAL(){
          return this.LOAD_TOTAL - this.CHECKER_FULLS_TOTAL 
      },
      CHECKER_SALES_TOTAL(){
          return this.CHECKER_SOLD_TOTAL +  this.SOLD_DEPOSIT_TOTAL - this.CHECKER_EMPTIES_TOTAL - this.DISCOUNT_TOTAL
      },
      SUMMARY(){
        return [
          {label:"GENERATED", fulls: this.SOLD_TOTAL, deposit: this.SOLD_DEPOSIT_TOTAL, empties: this.RETURNED_EMPTIES_TOTAL, discount:this.DISCOUNT_TOTAL, amount:this.SALES_TOTAL },
          {label:"CHECKER", fulls: this.CHECKER_SOLD_TOTAL, deposit: this.SOLD_DEPOSIT_TOTAL, empties: this.CHECKER_EMPTIES_TOTAL, discount:this.DISCOUNT_TOTAL, amount: this.CHECKER_SALES_TOTAL },
        ]
      },
      SETTLEMENT_AMOUNT(){
          return  this.SALES_TOTAL - this.CHECKER_SALES_TOTAL
      }
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
      other_discounts(items){
          var arr = items?items:[]
          var total = arr.reduce((res,item)=>res +=this.$IsNum(item.amount),0)
          return total
      },
      Verified(status){
        this.checked.status = status
        this.checked.inbound_amount = this.SALES_TOTAL.toString()
        this.checked.verified_amount = this.CHECKER_SALES_TOTAL.toString()
        this.$http.post("delivery/save_report", this.checked).then(response => {
              this.GET_RESPONSE(response)
              }).catch(e => {
              console.log(e.data)
          })
      },
      confirmEnvent(e) {
        this.confirm = false
        if(e == 'ok') {
          this.dr.status = 'outbound'
          this.Save()
        }
      },
      printEvent(){
        this.print = false
      },
      fullEvent() {
        this.fullform = false
        this.borrowform = false
         this.getDr()
         this.GET_AVAILABLES()
      },
      getDr() {
        this.$http.post("delivery/view", {id:parseInt(this.$route.params.id)}).then(response => {
            response.data.delivery != null?this.dr = response.data.delivery:this.dr={}
            response.data.contents != null?this.fulls = response.data.contents:this.fulls=[]
            response.data.returned_empties != null?this.returned_empties = response.data.returned_empties:this.returned_empties=[]
            response.data.sales != null?this.sales = response.data.sales:this.sales=[]
            response.data.returned_fulls != null?this.returned_fulls = response.data.returned_fulls:this.returned_fulls=[]
            response.data.checker_items != null?this.checked = response.data.checker_items:this.checked=[]
             response.data.route != null?this.route = response.data.route:this.route=''
            console.log( response.data.returned_fulls)
         }).catch(e => {
           console.log(e.data)
         })
      },
       Save() {
         this.dr.load= this.LOAD_TOTAL
         this.dr.settlement = this.SETTLEMENT_AMOUNT
         this.$http.post("delivery/update", this.dr).then(response => {
              this.GET_RESPONSE(response)
           this.getDr()
         }).catch(e => {
           console.log(e.data)
         })
      },
      RemoveItem(item) {
        this.$http.post("delivery/remove_item", item).then(response => {
              response.data.status?this.VA_ALERT("success", response.data.message):this.VA_ALERT("error", response.data.message)
           this.getDr()
           this.GET_AVAILABLES()
         }).catch(e => {
           console.log(e.data)
         })
      }
    },
  }
</script>